export default __webpack_public_path__ + "static/bg-promo-video-c00b2b32682b79d84c97d926afb70a6e.mp4";